<template>
  <v-container fluid>
    <v-layout row wrap align-center justify-center>
      <v-flex xs12 sm12 md6>
        <v-card class="elevation-12">
          <v-toolbar dark color="red darken-1">
            <v-toolbar-title class="display-small">Welcome to eWak, stay Connected</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 sm12 class="welcome-div">
                <span class="welcome-txt">Your professional networking Partner</span>
              </v-flex>
              <v-flex xs12 sm4>
                <v-spacer></v-spacer>
                <v-btn :to="`/login/sonko/normal`" color="green darken-1" class="left landing-btn" dark>Sonko (Employer)</v-btn>
              </v-flex>
              <v-flex xs12 sm4>
                <v-spacer></v-spacer>
                <v-btn :to="`/login/vip_sonko/normal`" color="orange darken-1" class="left landing-btn" dark>VIP Sonko (Employer)</v-btn>
              </v-flex>
              <v-flex xs12 sm4>
                <v-spacer></v-spacer>
                <v-btn :to="`/login/expert/normal`" color="blue darken-1" class="right landing-btn" dark>Expert (Service Provider)</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {};
</script>

<style scoped>
.sec-one {
  display: flex;
  justify-content: center;
}

.sec-two {
  display: flex;
  height: 300px;
  align-items: center;
  justify-content: center;
}

.sec-three {
  display: flex;
  height: 300px;
  align-items: center;
  justify-content: center;
}

.main-section {
  background-size: cover;
  background-repeat: no-repeat;
}

.welcome-txt {
  color: #808080;
  font-size: 19px;
}
.welcome-div {
  padding: 50px 0px 60px 10px;
  text-align: center;
}
.landing-btn {
  text-transform: unset;
}
.display-small {
  font-size: 18px;
}
@media only screen and (max-width: 572px) {
  .display-small {
    font-size: 14px;
  }
}
@media only screen and (max-width: 600px) {
  .right {
    float: left !important;
  }
}
</style>